/*
 * A seção "Perfil" nas Configurações, logo depois de "Conta" — a ordem das
 * preferências (Conta, Perfil, Notificações…).
 *
 * O SettingsPage é carregado sob demanda (rota com import()), por isso o
 * extend usa o nome do módulo e não a classe importada.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import FieldSet from 'flarum/common/components/FieldSet';
import { t } from '../../utils/settings';
import { thirdParty } from '../../thirdparty/settings';
import { canEditProfile, profileEnabled, profileField } from './data';
import { beforeChunk, once } from '../../utils/chunkGate';
import { lazyComponent } from '../../utils/lazy';

// O formulário do perfil é um chunk: desce junto com o da página de
// Configurações do core, então já está pronto no primeiro desenho dela.
const loadSection = once(() => import(/* webpackChunkName: 'forum/features/profile/ProfileSettingsSection', webpackMode: 'lazy-once' */ './ProfileSettingsSection').then(mod => mod.default));
let Section = null;
const LazySection = lazyComponent(loadSection);
const FIELDS = ['bio', 'location', 'website', 'title', 'status', 'cover', 'birthday'];
export default function installSettingsPage() {
  beforeChunk((namespace, url) => namespace === 'core' && /\/forum\/components\/SettingsPage\.js/.test(url), () => loadSection().then(component => Section = component));
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    const user = this.user;
    if (!user || user !== app.session.user || !profileEnabled() || !canEditProfile(user)) return;
    // A capa da forumaker (thirdparty/profileCover) também pede a seção, mesmo com a capa interna desligada.
    if (!FIELDS.some(field => profileField(field)) && !thirdParty.profileCover()) return;
    items.add('canelaProfile', m(FieldSet, {
      className: "Settings-canelaProfile FieldSet--col",
      label: t('profile.settings.heading')
    }, Section ? m(Section, {
      key: user.id(),
      user: user
    }) : m(LazySection, {
      key: user.id(),
      user: user
    })), 95);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/profile/settingsPage', installSettingsPage);flarum.reg.addChunkModule('forum/features/profile/ProfileSettingsSection', './src/forum/features/profile/ProfileSettingsSection.tsx', 'ramon-canela', 'forum/features/profile/ProfileSettingsSection');
flarum.reg.addChunkModule('forum/features/profile/ProfileSettingsSection', './src/forum/features/profile/ProfileSettingsSection.tsx', 'ramon-canela', 'forum/thirdparty/profileCover');
flarum.reg.addChunkModule('forum/features/profile/ProfileSettingsSection', './src/forum/features/profile/ProfileSettingsSection.tsx', 'ramon-canela', 'forum/features/profile/EmojiPicker');
flarum.reg.addChunkModule('forum/features/profile/ProfileSettingsSection', './src/forum/features/profile/ProfileSettingsSection.tsx', 'ramon-canela', 'forum/features/profile/ImageField');